/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import BulmaButton from 'react-bulma-components/lib/components/button';
import BulmaColumns from 'react-bulma-components/lib/components/columns';
import BulmaContainer from 'react-bulma-components/lib/components/container';
import BulmaSection from 'react-bulma-components/lib/components/section';

import { Heading, LazyLink } from '../atoms';

import {
  styledCTAWrapper,
  styledHeading,
  styledButtonsContainer,
  styledButtonColumn,
  styledSubheading,
  styledHr,
} from './CTABandStyles';

const renderHeading = (text, atts) => <Heading {...atts}>{text.text}</Heading>;

const renderButton = (link, text, atts) => (
  <LazyLink {...atts} url={link.url}>
    {text.text}
  </LazyLink>
);

const CTABand = ({ input }) => {
  const {
    text_color,
    background_image,
    background_color,
    heading,
    subheading,
    cta_primary_centered,
    cta_primary_hr,
    cta_primary_background_color,
    cta_url_primary,
    cta_text_primary,
    cta_url_secondary,
    cta_text_secondary,
  } = input.primary;

  return (
    <BulmaSection
      css={styledCTAWrapper}
      style={{
        backgroundImage: `url(${background_image && background_image.url ? background_image.url : null})`,
        backgroundColor: background_color,
      }}
    >
      <BulmaContainer>
        <BulmaColumns>
          {!cta_primary_centered ? (
            <BulmaColumns.Column size={7}>
              {heading && heading[0]
                ? renderHeading(heading[0], {
                    className: text_color === 'light' ? 'h2 white' : 'h2 darkblue',
                    css: styledHeading,
                  })
                : null}
              {subheading &&
                subheading[0].text &&
                renderHeading(subheading[0], {
                  className: text_color === 'light' ? 'medium white' : 'medium darkgrey',
                  subtitle: true,
                  renderAs: 'p',
                  css: styledSubheading,
                })}
            </BulmaColumns.Column>
          ) : null}
          <BulmaColumns.Column className={`${!cta_primary_centered ? '' : 'is-centered'}`} css={styledButtonColumn}>
            {cta_primary_hr ? <hr css={styledHr} /> : null}
            <BulmaButton.Group css={styledButtonsContainer}>
              {cta_url_secondary && cta_text_secondary && cta_url_secondary.url
                ? renderButton(cta_url_secondary, cta_text_secondary[0], {
                    className: 'button-link is-white is-outlined',
                  })
                : null}
              {cta_text_primary &&
                cta_text_primary[0].text &&
                cta_url_primary &&
                renderButton(cta_url_primary, cta_text_primary[0], {
                  className: `${
                    cta_primary_background_color === 'white' ? 'button-link is-white' : 'button-link is-primary'
                  }`,
                })}
            </BulmaButton.Group>
          </BulmaColumns.Column>
        </BulmaColumns>
      </BulmaContainer>
    </BulmaSection>
  );
};

export default CTABand;

CTABand.propTypes = {
  input: PropTypes.object.isRequired,
};
